import { render, staticRenderFns } from "./DeliveriesPerDay.vue?vue&type=template&id=04d7644b&"
import script from "./DeliveriesPerDay.vue?vue&type=script&lang=js&"
export * from "./DeliveriesPerDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports